import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import "./defaultFormSelect.scss";
import "../FormSelect/formSelect.scss";
export const DefaultFormSelect = ({ options, name, onChange, label, className, value }) => {
    const [state, setState] = useState(value || "Alabama");
    const onChangeHandler = (e) => {
        setState(e.target.value);
        onChange(e.target.value, name);
    };
    return (_jsxs("div", { className: `form-select ${className || ""}`, children: [_jsx("label", { htmlFor: "defaultSelect", className: "select-label input-form-control__label", children: label }), _jsx("select", { name: "defaultSelect", id: "defaultSelect", value: state, onChange: onChangeHandler, className: "form-select_option", children: options.map((option) => (_jsx("option", { value: option.value, className: "form-select_option", children: option.label }, option.label))) })] }));
};
